import { render } from "./Themes.vue?vue&type=template&id=0c51e883&scoped=true"
import script from "./Themes.vue?vue&type=script&lang=ts"
export * from "./Themes.vue?vue&type=script&lang=ts"

import "./Themes.vue?vue&type=style&index=0&id=0c51e883&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c51e883"

export default script